import { PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

type Props = PropsWithChildren<{
  className?: string
}>

const LabelText = (props: Props): ReactElement => {
  const { className, children } = props

  return <span className={classNames('label-text', className)}>{children}</span>
}

export default LabelText